import * as React from 'react'

interface IStarProps {
  width?: number
  height?: number
}

const StarSmall = ({ width = 8, height = 8 }: IStarProps) => (
  <svg width={8} height={8} viewBox="0 0 8 8" fill="none">
    <path
      d="M3.63614 1.10548C3.18084 2.51126 2.24513 3.5285 0.830553 3.98118C0.682045 4.02859 0.581698 4.16254 0.581522 4.31347C0.580858 4.74033 1.01864 4.56938 1.91035 5.15882C1.91035 5.15882 1.91035 5.15882 1.91039 5.15895C2.72599 5.69778 3.30635 6.49155 3.63534 7.51813C3.6824 7.66493 3.82286 7.76512 3.98207 7.76538C3.97238 7.76858 4.24759 7.77234 4.32967 7.51937C4.77453 6.1479 5.70366 5.11645 7.1357 4.6435C7.46275 4.53546 7.46239 4.0876 7.13575 3.97968C5.69437 3.50354 4.77122 2.46398 4.33012 1.10523C4.28262 0.958985 4.14212 0.8593 3.98317 0.8593C3.99365 0.855844 3.71796 0.853027 3.63614 1.10548Z"
      fill="#FFE354"
    />
  </svg>
)

export default StarSmall;